import { WSDataItem, WSDataItemProps } from "@wingspanhq/fe-component-library";
import { formatter } from "../utils/formatter";

export const DataItem: React.FC<WSDataItemProps> = props => (
  <>
    <WSDataItem formatter={formatter} {...props} />
    {props.children}
  </>
);
